import { render, staticRenderFns } from "./SportProgramContent.vue?vue&type=template&id=67a1456d&scoped=true&"
import script from "./SportProgramContent.vue?vue&type=script&lang=js&"
export * from "./SportProgramContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a1456d",
  null
  
)

export default component.exports